module.exports = __webpack_public_path__ + "media/opening.9b06242d.mp3";